/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from '../../Button/Button';
import { Flex, Text } from '@getgo/chameleon-chakra-ui';
import {
  useSendTelemetry,
  TelemetryComponent,
  TelemetryAction,
  TelemetryState,
} from '../../../hooks/useSendTelemetry';

interface Props {
  nativeDownloadUrl: string;
  onDownloadButtonClick: () => void;
}

const messages = defineMessages({
  heading: {
    id: 'install.heading',
  },
  nativeDownloadButton: {
    id: 'firstJoinNative.nativeDownloadButton',
  },
});

export const InstallPage: React.FC<Props> = (props) => {
  const { nativeDownloadUrl, onDownloadButtonClick } = props;
  const { formatMessage: f } = useIntl();
  const sendTelemetry = useSendTelemetry();
  const handleNativeDownloadClick = () => {
    sendTelemetry(
      TelemetryComponent.Native,
      TelemetryAction.Download,
      TelemetryState.First
    );
    onDownloadButtonClick();
  };
  return (
    <Flex direction='column' alignItems='center' mt='22vh' width='100%'>
      <Flex
        direction='column'
        alignItems='center'
        maxWidth='600px'
        textAlign='center'
        mb='2vh'
      >
        <Text as='h1'>{f(messages.heading)}</Text>
      </Flex>
      <Button
        link={nativeDownloadUrl}
        onClick={handleNativeDownloadClick}
        size='2xl'
        my={5}
      >
        {f(messages.nativeDownloadButton)}
      </Button>
    </Flex>
  );
};
